import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useImmer } from 'use-immer'
import { useMediaQueryUtils } from 'constants/exportHooks'

import {
    getIssuesList,
    getIssuesStats,
    filterIssues,
    getMoreIssues,
} from 'store/issues/actions'
import Spinner from 'components/common/Spinner'
import IssueCard from './card'
import useLoadMoreOnScroll from 'hooks/useLoadMoreOnScroll'

const queryString = require('query-string')

const ViewIssues = (props) => {
    // define state
    const dispatch = useDispatch()
    const { isDesktop, isMobile, isTablet } = useMediaQueryUtils()
    const [internalState, setState] = useImmer({
        sortIssuesByLabel: 'added&reverse=true',
        sortLabels: [
            { label: 'Release Date', key: 'added&reverse=true' },
            { label: 'Name', key: 'name' },
            { label: 'Category', key: 'category' },
            { label: 'Severity', key: 'severity' },
        ],
        sortQueryParams: 'added&reverse=true',
        filterQueryParams: {},
        isLoading: false,
        isSort: null,
        toggleSortModal: false,
        toggleFilterModal: false,
    })
    const issueStore = useSelector((state) => state.issues)

    useLoadMoreOnScroll(
        issueStore?.list?.count,
        issueStore?.list?.data,
        issueStore?.list?.nextPage,
        (string) => dispatch(getMoreIssues(string))
    )

    // call API on component mount
    useEffect(() => {
        window.history.pushState(
            {},
            document.title,
            '/?sort=added&reverse=true'
        )
        setState((draft) => {
            draft.isLoading = true
        })
        dispatch(getIssuesList(`?sort=added&reverse=true`))
        dispatch(getIssuesStats())
    }, [])

    const {
        sortIssuesByLabel,
        sortLabels,
        sortQueryParams,
        isLoading,
        isSort,
        toggleFilterModal,
        toggleSortModal,
        filterQueryParams,
    } = internalState

    const performFilterIssues = (field, value) => {
        setState((draft) => {
            draft.isLoading = true
            draft.isSort = null
            draft.filterQueryParams = {
                field,
                value,
            }
        })
    }

    const resetSortIssues = () => {
        console.log('reset filter')
        setState((draft) => {
            draft.isLoading = true
            draft.filterQueryParams = {}
            draft.sortQueryParams = 'added&reverse=true'
            draft.sortIssuesByLabel = 'added&reverse=true'
        })
        dispatch(getIssuesList('?sort=added&reverse=true'))
    }

    // const updateFilterQueryParams = (field, value) => {
    //     if (field && value) {
    //         // this indicates filter params are available and should be updateed
    //         setState((draft) => {
    //             draft.isLoading = true
    //             draft.filterQueryParams = {
    //                 field,
    //                 value,
    //             }
    //         })
    //     } else {
    //         let str = ''
    //         // this indicates reset filter hence execute query with existing params
    //         setState((draft) => {
    //             draft.isLoading = true
    //             draft.filterQueryParams = {}
    //         })
    //         if (sortQueryParams) {
    //             str = str + `?sort=${sortQueryParams}`
    //         }
    //         dispatch(filterIssues(str))
    //     }
    // }

    const executeQuery = () => {
        const filterQueryParams = queryString.parse(window.location.search)

        console.log('filterQueryParams', filterQueryParams)
        let str = ''
        if (sortQueryParams) {
            str = str + `?sort=${sortQueryParams}`
        }

        if (
            filterQueryParams?.filter_values?.length > 0 &&
            filterQueryParams?.filter_fields?.length > 0
        ) {
            if (str !== '') {
                str =
                    str +
                    `&filter_values=${filterQueryParams.filter_values}&filter_fields=${filterQueryParams.filter_fields}`
            } else {
                str = `?filter_values=${filterQueryParams.filter_values}&filter_fields=${filterQueryParams.filter_fields}`
            }
        }

        dispatch(filterIssues(str))
    }

    useEffect(() => {
        const filterQueryParams = queryString.parse(window.location.search)
        console.log('filterQueryParams', filterQueryParams)
        if (
            sortQueryParams !== null ||
            (filterQueryParams?.filter_values?.length > 0 &&
                filterQueryParams?.filter_fields?.length > 0)
        ) {
            executeQuery()
        }
    }, [sortQueryParams])

    const renderSortByLabel = () => {
        const queryParams = queryString.parse(window.location.search)
        return sortLabels.map((item, index) => (
            <React.Fragment key={index}>
                <button
                    className={
                        sortIssuesByLabel === item.key
                            ? `flex-none ml-2 px-2 py-1 rounded text-neutral-gray-500 font-semibold bg-primary-purple-100 border border-primary-purple-300 focus:outline-none`
                            : `flex-none ml-2 px-2 py-1 rounded text-neutral-gray-500 font-semibold bg-neutral-gray-50 hover:bg-primary-purple-100 border border-neutral-gray-100 focus:outline-none`
                    }
                    onClick={() => {
                        let str = `?sort=${item.key}`
                        if (item.key !== sortQueryParams) {
                            if (
                                queryParams?.filter_fields &&
                                queryParams?.filter_values &&
                                queryParams?.sort
                            ) {
                                window.history.pushState(
                                    {},
                                    document.title,
                                    `?sort=${item.key}&filter_values=${queryParams.filter_values}&filter_fields=${queryParams.filter_fields}`
                                )
                            } else if (queryParams?.sort) {
                                window.history.pushState(
                                    {},
                                    document.title,
                                    `?sort=${item.key}`
                                )
                            } else {
                                window.history.pushState({}, document.title, '')
                            }

                            setState((draft) => {
                                draft.sortQueryParams = item.key
                                draft.sortIssuesByLabel = item.key
                                draft.isLoading = true
                                draft.isSort = true
                            })
                        }
                    }}
                >
                    {item.label}
                </button>
            </React.Fragment>
        ))
    }

    const renderList = () => {
        console.log('issueStore in render list', issueStore)

        return (
            <div>
                {issueStore.list?.data?.length > 0 ? (
                    issueStore.list?.data?.map((item, index) => (
                        <React.Fragment key={item.name}>
                            <IssueCard
                                isMobile={isMobile}
                                item={item}
                                filterHighlight={filterQueryParams.field}
                                navigateToIssue={() =>
                                    props.history.push(
                                        `issue-details/${item.name}`
                                    )
                                }
                            />
                        </React.Fragment>
                    ))
                ) : (
                    <React.Fragment>
                        <div className="p-10 flex items-center justify-center w-full">
                            No data to be shown
                        </div>
                    </React.Fragment>
                )}
                {issueStore.list.loading && (
                    <React.Fragment>
                        <div className="p-10 flex items-center justify-center w-full">
                            <Spinner loaderSize="lg" color="#6157E5" />
                        </div>
                    </React.Fragment>
                )}
            </div>
        )
    }

    return (
        <React.Fragment>
            <div className="view-issues-container">
                <div className="flex flex-wrap">
                    <div className={`w-full sm:w-full `}>
                        <div className=" text-page-title font-bold">
                            {issueStore.list?.count || 0}
                            <span className=" text-primary-purple-500 px-2">
                                Issues
                            </span>
                            found
                        </div>
                        {isDesktop && (
                            <React.Fragment>
                                <div className="mt-2 flex  items-center w-full">
                                    <div className="w-full lg:w-5/6 flex items-center">
                                        <div className=" text-issue-card-desc text-neutral-gray-350 ">
                                            Sort Issues By:
                                        </div>
                                        <div className="flex-wrap sm:flex-no-wrap  ">
                                            {renderSortByLabel()}
                                        </div>
                                    </div>
                                </div>
                            </React.Fragment>
                        )}

                        {/* {isMobile || isTablet ? (
                                <div className="flex items-center justify-center mt-5 sm:mt-6 ">
                                    <button
                                        className="flex 
                    text-base lg:text-md 
                    px-8 py-1 bg-white text-primary-500 border-primary-500 border outline-none"
                                        onClick={() => {
                                            setState((draft) => {
                                                draft.toggleSortModal = true
                                            })
                                        }}
                                    >
                                        {' '}
                                        Sort{' '}
                                        <Image
                                            addClass="pl-2"
                                            src={SortIcon}
                                            width={30}
                                            height={30}
                                        />
                                    </button>
                                    <button
                                        className="flex 
                    text-base lg:text-md 
                    px-8 py-1 bg-white text-primary-500 border-primary-500 border outline-none"
                                        onClick={() => {
                                            setState((draft) => {
                                                draft.toggleFilterModal = true
                                            })
                                        }}
                                    >
                                        {' '}
                                        Filter{' '}
                                        <Image
                                            addClass="pl-2"
                                            src={FilterIcon}
                                            width={30}
                                            height={30}
                                        />
                                    </button>
                                    <Rodal
                                        className="rodal-sort-container"
                                        visible={toggleSortModal}
                                        onClose={() => {
                                            setState((draft) => {
                                                draft.toggleSortModal = false
                                            })
                                        }}
                                        customStyles={{
                                            width: '90%',
                                            height: '300px',
                                        }}
                                        closeMaskOnClick={true}
                                        closeOnEsc={true}
                                        animationType="enter"
                                        showCloseButton={false}
                                    >
                                        {' '}
                                        <div className="top-toolbar mt-6 flex items-center">
                                            <div className="px-4 text-md">
                                                Sort Issues By:
                                            </div>
                                            <div className="flex-wrap sm:flex-no-wrap  ">
                                                {renderSortByLabel()}
                                            </div>
                                        </div>
                                    </Rodal>

                                    <Rodal
                                        className="rodal-filter-container"
                                        visible={toggleFilterModal}
                                        onClose={() => {
                                            setState((draft) => {
                                                draft.toggleFilterModal = false
                                            })
                                        }}
                                        customStyles={{
                                            width: '90%',
                                            height: '700px',
                                        }}
                                        closeMaskOnClick={true}
                                        closeOnEsc={true}
                                        animationType="enter"
                                        showCloseButton={false}
                                    >
                                        {' '}
                                        <div className="w-full h-auto px-5 my-5 right-0">
                                            <ViewIssueStats
                                                stats={issueStore.issueStats}
                                                filterIssues={
                                                    performFilterIssues
                                                }
                                                resetFilterIssues={
                                                    resetSortIssues
                                                }
                                                filterQueryParams={
                                                    filterQueryParams
                                                }
                                            />
                                        </div>
                                    </Rodal>
                                </div>
                            ) : null} */}

                        <div className="main-listing mt-2 sm:mt-6 pb-4">
                            {renderList()}
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default ViewIssues
